import React, { useState } from 'react';
import { setStoredRaceCode } from '../user';

export default function RaceCodeGate({ race, onVerified, error: externalError }) {
  const [code, setCode] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    const normalized = code.trim().toUpperCase();
    setStoredRaceCode(race.id, normalized);
    onVerified(normalized);
  };

  const raceName = race?.name || 'this race';

  return (
    <div style={{
      position: 'relative',
      overflow: 'hidden',
      background: '#111',
      borderRadius: 8,
      border: '1px solid #222',
      borderLeft: '4px solid #e8002d',
      padding: '40px 32px',
      marginBottom: 24,
    }}>
      {/* Watermark */}
      <span style={{
        position: 'absolute',
        right: -8,
        bottom: -16,
        fontFamily: 'var(--font-display)',
        fontSize: 140,
        fontWeight: 800,
        color: 'rgba(232,0,45,0.05)',
        lineHeight: 1,
        pointerEvents: 'none',
        userSelect: 'none',
        letterSpacing: '-0.04em',
      }}>
        {race?.round || '?'}
      </span>

      {/* Content */}
      <div style={{ position: 'relative', maxWidth: 440 }}>
        <p style={{
          fontFamily: 'var(--font-mono)',
          fontSize: 11,
          fontWeight: 700,
          color: '#e8002d',
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          marginBottom: 12,
        }}>
          {raceName} · Invitation Only
        </p>

        <h2 style={{
          fontFamily: 'var(--font-display)',
          fontSize: 36,
          fontWeight: 700,
          lineHeight: 1.05,
          marginBottom: 12,
          color: '#f0f0f0',
          textTransform: 'uppercase',
          letterSpacing: '0.01em',
        }}>
          Enter your<br />race code
        </h2>

        <p style={{ color: '#777', fontSize: 14, lineHeight: 1.6, marginBottom: 28 }}>
          This race requires an invite code. Enter the code from your host to submit your prediction.
        </p>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={code}
            onChange={e => { setCode(e.target.value.toUpperCase()); }}
            placeholder="RACE CODE"
            autoFocus
            autoComplete="off"
            spellCheck={false}
            style={{
              width: '100%',
              padding: '14px 16px',
              background: '#0a0a0a',
              border: `1px solid ${externalError ? '#e8002d' : '#333'}`,
              borderRadius: 4,
              color: '#f9b000',
              fontSize: 22,
              fontFamily: 'var(--font-mono)',
              fontWeight: 700,
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              textAlign: 'center',
              marginBottom: 8,
              outline: 'none',
              boxSizing: 'border-box',
            }}
          />
          {externalError && (
            <p style={{ color: '#e8002d', fontSize: 13, marginBottom: 12 }}>{externalError}</p>
          )}
          <button
            type="submit"
            disabled={!code.trim()}
            style={{
              width: '100%',
              padding: '12px 24px',
              background: code.trim() ? '#f9b000' : '#2a2a2a',
              border: 'none',
              borderRadius: 4,
              color: code.trim() ? '#111' : '#555',
              fontFamily: 'var(--font-display)',
              fontWeight: 700,
              fontSize: 15,
              textTransform: 'uppercase',
              letterSpacing: '0.06em',
              cursor: code.trim() ? 'pointer' : 'not-allowed',
              transition: 'background 0.15s, color 0.15s',
              marginBottom: 16,
            }}
          >
            Unlock Race →
          </button>
        </form>

        <p style={{ fontSize: 12, color: '#444', lineHeight: 1.5 }}>
          Your code is remembered for this race — you only need to enter it once.
        </p>
      </div>
    </div>
  );
}
